module.exports = __webpack_public_path__ + "img/feature-online-store.151d1884.svg";